import React, { useContext } from "react";
import Layout from "../Layout";
import { NavLink } from "react-router-dom";
import Contact from "../components/Contact";
import { LoadContext } from "../App";
import { Helmet } from "react-helmet";

const Ensavoirplus = () => {
  const { load } = useContext(LoadContext);
  console.log("Page Nous connaitre");
  console.log(load);

  return (
    <>
      <Helmet>
        <title>En savoir plus | Vialle Construction</title>
        <meta
          name="description"
          content="Vialle Construction est une entreprise de construction éco-performante située à Sainte-Adèle qui vous accompagne de l’idée à la réalisation de votre projet. Vous méritez un espace de vie sain et performant"
        />
        <link
          rel="canonical"
          href="https://vialleconstruction.ca/Ensavoirplus"
        />
        <meta
          property="og:title"
          content="En savoir plus | Vialle Construction"
        />
        <meta
          property="og:description"
          content="Vialle Construction est une entreprise de construction éco-performante située à Sainte-Adèle qui vous accompagne de l’idée à la réalisation de votre projet. Vous méritez un espace de vie sain et performant"
        />
        <meta
          property="og:url"
          content="https://vialleconstruction.ca/Ensavoirplus"
        />
        <meta
          property="og:image"
          content="https://vialleconstruction.ca/assets/logo.png"
        />
      </Helmet>
      <Layout>
        <div className="EnsavoirplusPage">
          <img
            src="./assets/miniature/connaitre.webp"
            alt="fond d'écran"
            style={{ display: "none" }}
          />
          <img
            src="./assets/miniature/connaitre2.webp"
            alt="fond d'écran"
            style={{ display: "none" }}
          />
          <div className="one-page">
            <div className="title">
              <h1>
                Une entreprise de construction éco-performante située à
                Sainte-Adèle
              </h1>
            </div>
            <p className="intro">
              Un bâtiment sain et performant oui ! Accessible seulement aux
              grandes bourses, non ! Du design à la construction misez sur la
              performance et l'écologie accompagnée par Vialle Construction.
            </p>
            <div
              className="parcours-container"
              style={load ? { display: "flex" } : { display: "none" }}
            >
              <div className="container">
                <h3>
                  un parcours, <span>une histoire</span>
                </h3>
                <h4>
                  Ludovic VIALLE, - 31 ans - Dessinateur et expert en bâtiment
                </h4>
                <p>
                  Une enfance au coté d'un père ébéniste, une époque de
                  transition, de la détermination et l'obtention d'un diplôme de
                  dessinateur en bâtiment a permis d'ouvrir la brèche de la{" "}
                  <span>construction</span> au Québec a 24 ans.
                </p>
                <p>
                  Passionné d'architecture, d'optimisation et de solutions
                  durables je me lance à cœur ouvert dans le bâtiment
                  éco-performant. Les valeurs de SolutionEra et du{" "}
                  <NavLink to={"/Realisations"}>
                    <span>design</span>
                  </NavLink>{" "}
                  de bâtiment écologique agrémentent mes connaissances et mes
                  idées de solutions. A la suite de mon auto-construction et 5
                  ans d'expériences entre apprentissage, conception et
                  construction un objectif devient évident :
                </p>
                <p>
                  Rendre accessible le bâtiment éco-performant. Vialle
                  construction ouvre ses portes.
                </p>
              </div>
            </div>
          </div>
          <div className="contacts-connaitre">
            <h2>une idée de projet ?</h2>
            <div className="contacts-connaitre-bottom">
              <div className="contact-connaitre">
                <Contact />
              </div>
              <div className="map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4297.622410135089!2d-74.11416682275174!3d46.00594639712833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccf3866c6a4a823%3A0x9b2e23cecc9f06f9!2s2945%20Rue%20des%20Vers-Luisants%2C%20Sainte-Adele%2C%20QC%20J8B%202C9%2C%20Canada!5e1!3m2!1sfr!2sfr!4v1749318153703!5m2!1sfr!2sfr"
                  width="600"
                  height="450"
                  allowfullScreen=""
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Ensavoirplus;
